<header
  [class]="
    isScrolled ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
  "
  class="fixed top-0 left-0 right-0 z-50 bg-gray-100 shadow-lg border-b-2 transition-all duration-300 sticky-header flex items-center justify-center p-2"
  role="banner"
>
  <!-- Mobile/Tablet Layout -->
  <nav
    class="flex items-center justify-between gap-1 xl:hidden w-full px-2 pr-3"
    role="navigation"
    aria-label="Navegación móvil"
  >
    <ng-container [ngTemplateOutlet]="mobileMenuButton"></ng-container>
    <ng-container [ngTemplateOutlet]="mobileSearchBar"></ng-container>
    <ng-container [ngTemplateOutlet]="mobileCart"></ng-container>
    <ng-container [ngTemplateOutlet]="mobileSeparator"></ng-container>
    <ng-container [ngTemplateOutlet]="mobileUserMenu"></ng-container>
  </nav>

  <!-- Desktop Layout -->
  <nav
    class="hidden xl:flex items-center gap-4 w-full px-4"
    role="navigation"
    aria-label="Navegación principal"
  >
    <ng-container [ngTemplateOutlet]="desktopMenuButton"></ng-container>
    <ng-container [ngTemplateOutlet]="desktopLogo"></ng-container>
    <ng-container [ngTemplateOutlet]="desktopVehicleGarage"></ng-container>
    <ng-container [ngTemplateOutlet]="desktopSearchBar"></ng-container>
    <ng-container [ngTemplateOutlet]="desktopStoreGarage"></ng-container>
    <ng-container [ngTemplateOutlet]="desktopUserMenu"></ng-container>
  </nav>
</header>

<!-- Spacer para evitar que el contenido salte cuando aparece la barra sticky -->
@if(isScrolled) {
<div class="h-12" role="presentation"></div>
}

<!-- Mobile/Tablet Templates -->
<ng-template #mobileMenuButton>
  <button
    (click)="onToggleSidebar()"
    class="flex gap-2 items-center p-1 text-gray-700 transition-colors"
    aria-label="Abrir menú de navegación"
    type="button"
  >
    <img
      src="/allas-icons/hamburger_icon.svg"
      alt="Icono de menú"
      class="w-auto h-4"
      width="16"
      height="16"
      loading="eager"
    />
  </button>
</ng-template>

<ng-template #mobileSearchBar>
  <div class="flex-1 relative mx-2">
    <allas-search-bar
      inputStyleClass="h-10"
      [isInStickyHeader]="true"
    ></allas-search-bar>
  </div>
</ng-template>

<ng-template #mobileCart>
  <allas-cart-mini [isInStickyHeader]="true"></allas-cart-mini>
</ng-template>

<ng-template #mobileSeparator>
  <div
    class="w-px h-6 bg-gray-300 mx-1 lg:mx-2 flex-shrink-0 mr-2"
    role="separator"
    aria-hidden="true"
  ></div>
</ng-template>

<ng-template #mobileUserMenu>
  <allas-user-menu [isInStickyHeader]="true"></allas-user-menu>
</ng-template>

<!-- Desktop Templates -->
<ng-template #desktopMenuButton>
  <button
    (click)="onToggleSidebar()"
    class="flex gap-2 items-center p-3 text-gray-700 hover:text-allasRed transition-colors fs-condensed"
    aria-label="Abrir menú de navegación"
    type="button"
  >
    <img
      src="/allas-icons/hamburger_icon.svg"
      alt="Icono de menú"
      class="w-auto h-4"
      width="24"
      height="24"
      loading="eager"
    />
    <span class="text-sm font-semibold">Menú</span>
  </button>
</ng-template>

<ng-template #desktopLogo>
  <a
    class="flex items-center hover:scale-105 duration-150 ease-in-out"
    href="/"
    aria-label="Ir a página principal de ALLAS REPUESTOS"
  >
    <img
      src="/logos/default.webp"
      alt="ALLAS REPUESTOS"
      class="h-8 w-auto"
      width="120"
      height="32"
      loading="eager"
    />
  </a>
</ng-template>

<ng-template #desktopVehicleGarage>
  <allas-garage-dropdown whichShow="vehicle"></allas-garage-dropdown>
</ng-template>

<ng-template #desktopSearchBar>
  <div class="flex-1 relative">
    <allas-search-bar></allas-search-bar>
  </div>
</ng-template>

<ng-template #desktopStoreGarage>
  <allas-garage-dropdown whichShow="store"></allas-garage-dropdown>
</ng-template>

<ng-template #desktopUserMenu>
  <allas-user-menu [isInStickyHeader]="true"></allas-user-menu>
</ng-template>
